export default "__VITE_ASSET__BGNxlsWa__"